import Axios from "../../api/Axios";
const BASE_URL = "DistCollateralDispatchAdd/";
export const Endpoint = {
    PopulateData: "PopulateData",
    Update: "Update",
};

// /api/DistCollateralDispatchAdd/PopulateData
// /api/DistCollateralDispatchAdd/Update

export const createAPIdistCollatrldisp = () => {
    return {
        get: (Endpoint) => Axios.get(BASE_URL + Endpoint),
        post: (Endpoint, data) => Axios.post(BASE_URL + Endpoint, data),
    };
};